import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DailyCountWeeklyWidgetVm } from 'app/shared/generated/Dashboard/Models/DailyCountWeeklyWidgetVm';
import { DateRange } from 'app/shared/models/date-range';
import { subDays } from 'date-fns';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LandingService } from '../landing.service';

@Component({
    selector: 'pcg-daily-count-weekly',
    templateUrl: './daily-count-weekly.component.html',
    styleUrls: ['./daily-count-weekly.component.scss'],
    standalone: false
})
export class DailyCountWeeklyComponent implements OnInit {

  currentDate = new Date();
  filters = { dateRange: new DateRange(subDays(this.currentDate, 6), this.currentDate) };

  formGroup = DailyCountWeeklyWidgetVm.Form;
    model = DailyCountWeeklyWidgetVm.GetModel(this.formGroup);
    model$: Observable<DailyCountWeeklyWidgetVm>;    
    
    constructor(public landingService: LandingService, private router: Router) { }

    ngOnInit(): void {
      this.reloadTable();
    }

    linkClick(statusId: number) {
      const dtBegin = this.setBeginDate(); const dtEnd = this.setEndDate();
      this.router.navigate(['/reports/inventory-count'], {
          queryParams: {
              status: statusId,
              dateBegin: dtBegin,
              dateEnd: dtEnd
          }
      });
    }

    reloadTable() {
      const dtBegin = this.setBeginDate(); const dtEnd = this.setEndDate();
      const httpParams = new HttpParams()
            .set('dateBegin', dtBegin)
            .set('dateEnd', dtEnd);
        this.model$ = this.landingService.getDailyCountWeeklyWidgetVm(httpParams).pipe(
            tap((model: DailyCountWeeklyWidgetVm) => {
                this.formGroup.setValue(model);
            }));
    }

    setBeginDate() {
      if (!this.filters?.dateRange?.dateBegin != null) { return this.filters?.dateRange?.dateBegin?.toDateString(); }
      else { return ""; }
    }

    setEndDate() {
      if (!this.filters?.dateRange?.dateEnd != null) { return this.filters?.dateRange?.dateEnd?.toDateString(); }
      else { return ""; }
    }

}
